import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { globalModel } from "./global/GlobalModel";
import { initViewportFill } from "./utils/viewportFill";
import { applyMiniProgramPageTheme } from "./utils/miniProgramEnv";
import { useRouteShellBgSync } from "./utils/useRouteShellBgSync";
import PlatformHomePage from "./platform-home/PlatformHomePage";
import LoginPage from "./login/LoginPage";
import SpacePage from "./space/SpacePage";
import SpaceMineBenefitsPage from "./space/mine/SpaceMineBenefitsPage";
import SpaceMineOrdersPage from "./space/mine/SpaceMineOrdersPage";
import SpaceMineSettingsPage from "./space/mine/SpaceMineSettingsPage";
import SpaceMineOrderDetailPage from "./space/mine/SpaceMineOrderDetailPage";
import UserProfilePage from "./profile/UserProfilePage";
import SpaceProductSubscribePage from "./space/subscribe/SpaceProductSubscribePage";
import LegalDocPage from "./legal/LegalDocPage";
function AppLayout() {
  useRouteShellBgSync();

  useEffect(() => {
    applyMiniProgramPageTheme(window.location.pathname);
    void globalModel.init();
    return initViewportFill();
  }, []);

  return (
    <div className="lf-h5-app-shell">
      <Routes>
        <Route path="/" element={<PlatformHomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/legal/:slug" element={<LegalDocPage />} />
        <Route path="/space/:spaceId/mine/benefits" element={<SpaceMineBenefitsPage />} />
        <Route path="/space/:spaceId/mine/orders/:orderId" element={<SpaceMineOrderDetailPage />} />
        <Route path="/space/:spaceId/mine/orders" element={<SpaceMineOrdersPage />} />
        <Route path="/space/:spaceId/mine/settings" element={<SpaceMineSettingsPage />} />
        <Route path="/space/:spaceId/mine/profile" element={<UserProfilePage />} />
        <Route path="/space/:spaceId/subscribe/:spaceProductId" element={<SpaceProductSubscribePage />} />
        <Route path="/space/:spaceId" element={<Navigate to="home" replace />} />
        <Route path="/space/:spaceId/:tab" element={<SpacePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default AppLayout;
